function infiniteLoader() {
  let count = 2; //Page counter, start at 2
  let $infinite = $('.infinite-scroll-content');
  let total = parseInt($infinite.attr('data-total')); //total number of pages
  let load = false;

  $(window).scroll(function(){
    if ($(window).scrollTop() >= $(document).height() - $(window).height() - $('.site-footer').outerHeight() && !load){
      load = true;
     if (count > total){
       return false;
     } else {
       loadArticle(count);
       count++;
     }
    }
  });

  function loadArticle(pageNumber){
    $('.infinite-loader').addClass('active');

    $.ajax({
      url: mantion.ajaxurl,
      type:'POST',
      data : {
        'action': 'infinite_scroll',
        'loop_file': $infinite.attr('data-loop'),
        'post_type': $infinite.attr('data-posttype'),
        'page_no': pageNumber,
        'value': $infinite.attr('data-search'),
        'per_page': $infinite.attr('data-perpage'),
        'order': $infinite.attr('data-order'),
        'date': $infinite.attr('data-date'),
        'cat': $infinite.attr('data-category'),
      },
      success: function (html) {
        $('.infinite-loader').removeClass('active');
        $infinite.append(html);
        load = false;
      }
    });
    return false;
  }
}

export { infiniteLoader };